/**
 * A festive Christmas hat SVG that can be positioned on the greeting
 */
export function ChristmasHat() {
  return (
    <span className='absolute -top-3 -left-3 z-30'>
      <svg
        width='32'
        height='32'
        viewBox='0 0 32 32'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        className='rotate-[-20deg]'
        aria-hidden='true'
      >
        {/* Santa hat */}
        <path
          d='M16 4L8 20H24L16 4Z'
          fill='#DC2626'
          stroke='#B91C1C'
          strokeWidth='0.5'
        />
        {/* White trim */}
        <ellipse cx='16' cy='20' rx='8.5' ry='2' fill='white' />
        {/* White pom-pom */}
        <circle cx='16' cy='4' r='2.5' fill='white' />
        {/* Hat shadow/detail */}
        <path d='M16 4L12 14L16 20L20 14L16 4Z' fill='#991B1B' opacity='0.3' />
      </svg>
    </span>
  );
}
